import { FeatureFlag, ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import {
  TXTWCL_Please_Xa_hrefXXN0XXwithdrawX__ELL,
  TXTWCL_Please_be_aware_that_you_are_s_ELL
} from './ExclusionResponseWithdrawalMessage.messages.json';

interface Props {
  useLongMessage?: boolean;
}

export const ExclusionResponseWithdrawalMessage: React.FC<Props> = ({ useLongMessage = false }) => {
  const useWC2ResolverTag = useFeature(FeatureFlag.UseWC2ResolverTags);
  const cashoutResolverTag = useWC2ResolverTag ? ResolverTag.Withdrawal : ResolverTag.WC3Withdrawal;
  const translationTag = useLongMessage
    ? TXTWCL_Please_be_aware_that_you_are_s_ELL
    : TXTWCL_Please_Xa_hrefXXN0XXwithdrawX__ELL;
  const isEmbedded = useSelector(select.device.isEmbedded);

  const onEmbeddedWithdrawClick = () => {
    window.starsweb?.app.execute('cashier/cashout');
  };

  return (
    <Translation
      {...translationTag}
      values={{
        a: (msg: string) =>
          isEmbedded ? (
            <StarsLink onClick={onEmbeddedWithdrawClick}>{msg}</StarsLink>
          ) : (
            <ResolverLink resolverTag={cashoutResolverTag}>{msg}</ResolverLink>
          )
      }}
    />
  );
};
